// extracted by mini-css-extract-plugin
export default {"container":"R2-z","heading":"S2-z","links":"T2-z","copy":"U2-z","subCopy":"V2-z","linksLeft":"W2-z","linksCenter":"X2-z","linksRight":"Y2-z","link":"Z2-z","onlyLink":"_2-z"};